import React, { useContext, useMemo } from "react";
import { Badge, Menu, Select, Grid, Space, Flex } from "antd";
import { UserInfoContext } from "Context/CommonContext";
import useMasterContext from "Context/MasterContext";
import { useParams } from "react-router-dom";
import Typography from "Components/CommonComponents/Typography";

const { useBreakpoint } = Grid;

interface SubjectSidebarProps {
  batchDetailsData: any;
  selectedSubject: string;
  onSubjectSelect: (subject: string) => void;
}

const SubjectSidebar: React.FC<SubjectSidebarProps> = ({
  selectedSubject,
  onSubjectSelect,
  batchDetailsData,
}) => {
  const { id } = useParams();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const userInfo = useContext<any>(UserInfoContext);
  const { masters } = useMasterContext();
  const { unreadComments } = masters || {};

  const unreadCommentForBatch = useMemo(() => {
    if (unreadComments && id) {
      return unreadComments.find(
        (comment: any) => comment.batchId === parseInt(id)
      );
    }
  }, [unreadComments, id]);

  const unreadSubjects = unreadCommentForBatch?.subjects || [];
  const getUnreadCount = (subject: string) => {
    const unread_subject = unreadSubjects.find(
      (item: any) => item.subject === subject
    );
    return unread_subject ? unread_subject.postIds?.length : 0;
  };

  const stream = batchDetailsData?.academicGroup;
  const streams = masters?.streams || [];
  const streamId = streams?.find((s: any) => s.label === stream)?.id;
  const streamWiseSubjects = masters?.subjects
    ?.filter(
      (subject: any) =>
        subject.streamIds && subject.streamIds.includes(streamId)
    )
    .map((subject: any) => subject.label);
  const usersSubjects = (
    userInfo?.subjectsListing?.map((subject: any) => subject.label) || []
  ).filter((subject: any) => streamWiseSubjects?.includes(subject));
  const subjects = ["General", ...usersSubjects];
  return (
    <div
      style={{
        backgroundColor: "#fff",
        height: isMobile ? "auto" : "calc(100vh - 82px)",
        borderRight: isMobile ? "none" : "1px solid #f0f0f0",
        padding: isMobile ? "12px 16px" : "0",
        borderBottom: isMobile ? "1px solid #f0f0f0" : "none",
        overflowY: isMobile ? "visible" : "auto",
      }}
    >
      {!isMobile && (
        <div>
          <h3
            style={{
              paddingLeft: "16px",
              paddingTop: "16px",
              marginBottom: "16px",
              fontSize: "16px",
              fontWeight: 600,
            }}
          >
            Subjects
          </h3>
        </div>
      )}

      {isMobile ? (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Typography
            variant="body3"
            style={{ fontWeight: 500, color: "#8c8c8c" }}
          >
            Select Subject
          </Typography>
          <Select
            value={selectedSubject}
            onChange={(value) => onSubjectSelect(value)}
            style={{ width: "100%" }}
            placeholder="Select Subject"
            size="large"
          >
            {subjects.map((subject) => (
              <Select.Option key={subject} value={subject}>
                <Flex
                  justify="space-between"
                  align="center"
                  style={{ width: "100%" }}
                >
                  <span>{subject}</span>
                  {getUnreadCount(subject) > 0 && (
                    <Badge
                      count={getUnreadCount(subject)}
                      status="warning"
                      color={"#faad14"}
                      size="small"
                    />
                  )}
                </Flex>
              </Select.Option>
            ))}
          </Select>
        </Space>
      ) : (
        <Menu
          onClick={(e) => onSubjectSelect(e.key)}
          selectedKeys={[selectedSubject]}
          style={{ height: "100%", borderRight: 0 }}
          mode="inline"
          aria-label="Subjects"
        >
          {subjects.map((subject) => {
            const postIdsCount = getUnreadCount(subject);
            return (
              <Menu.Item key={subject}>
                <Badge
                  count={postIdsCount}
                  status="warning"
                  color={"#faad14"}
                  offset={[10, 0]}
                  size="small"
                  title="Unread Comments"
                >
                  {subject}
                </Badge>
              </Menu.Item>
            );
          })}
        </Menu>
      )}
    </div>
  );
};

export default SubjectSidebar;
